<template>
  <UiOverlay v-model="isActive" :close-on-overlay-click="false" :close-on-esc="false">
    <IconLoading width="40" height="40" />
  </UiOverlay>
</template>
<script lang="ts" setup>
import { useLayoutLoader } from '@/composables/loader'

const { isActive } = useLayoutLoader()
</script>
<style lang="sass" scoped>
@use '@/styles/variables'
@use "sass:map"

svg
    color: map.get(variables.$theme-color, 'primary')
</style>
